export type { TransactionalHistoryTableTranslations } from "./transactional-history-table-pt-br";
export { TRANSACTIONAL_HISTORY_TABLE_PT_BR } from "./transactional-history-table-pt-br";
export { TRANSACTIONAL_HISTORY_TABLE_ES_MX } from "./transactional-history-table-es-mx";
export { TRANSACTIONAL_HISTORY_TABLE_EN_US } from "./transactional-history-table-en-us";
export { TRANSACTIONAL_HISTORY_TABLE_FR_FR } from "./transactional-history-table-fr-fr";
